// Theme/tokens compartilhados pelos gráficos Recharts.
// Lê CSS vars do :root (definidas pelo tenant theme).
export function chartTheme() {
  const css = getComputedStyle(document.documentElement);
  return {
    primary: css.getPropertyValue("--color-primary").trim() || "#0f172a",
    accent:  css.getPropertyValue("--color-accent").trim()  || "#facc15",
    text:    "#1f2937",
    muted:   "#8a8270",
    grid:    "#e6e2d8",
    surface: "#ffffff",
    green:   "#047857",
    red:     "#b91c1c",
    amber:   "#b45309",
    palette: [] as string[], // preenche abaixo
  };
}

// Paleta editorial (combina com o estilo Nerea: preto + amarelo + tons sóbrios)
export const SERIES_COLORS = [
  "#131313",  // ink
  "#ffd000",  // yellow (accent Nerea)
  "#047857",  // green
  "#b91c1c",  // red
  "#7c3aed",  // violet
  "#0891b2",  // cyan
  "#b45309",  // amber
  "#9333ea",  // magenta
];

// Estilo padrão de Tooltip — branco, borda fina, font mono nos números
export const tooltipStyle = {
  contentStyle: {
    background: "#fff",
    border: "1px solid #e6e2d8",
    borderRadius: 6,
    fontSize: 13,
    padding: "8px 12px",
    boxShadow: "0 4px 16px rgba(0,0,0,.08)",
  } as React.CSSProperties,
  labelStyle: { color: "#8a8270", fontSize: 11, marginBottom: 4, fontFamily: "JetBrains Mono, monospace" } as React.CSSProperties,
  itemStyle:  { color: "#1f2937", fontSize: 13 } as React.CSSProperties,
};

// Margens default — deixa espaço pros labels
export const defaultMargin = { top: 8, right: 16, bottom: 0, left: 0 };
